<template>
  <form class="form" enctype="multipart/form-data" @submit.prevent="disabledSendForm">
    <div class="label-field">
      <b>Your contact name</b>
      <custom-input
          :no-emit="true"
          class="inp-form"
          :invalide="getErrorObj['name']"
          @input="inputContactName"
          type="text"
          name="name"
          placeholder="Name"
          :isReq="true"/>
    </div>
    <InfoMessage
        v-if="getErrorObj['name']"
        message-type="danger"
        :message-text="getErrorObj['name'].join(' ')"
        :maxWidth="700"/>
    <div class="label-field">
      <b>Your e-mail for feedback</b>
      <custom-input
          :no-emit="true"
          :class="['inp-form']"
          :invalide="getErrorObj['email']"
          @input="inputContactMail"
          type="email" name="email"
          placeholder="Email address"
          :isReq="true"/>
    </div>
    <InfoMessage
        v-if="getErrorObj['email']"
        message-type="danger"
        :message-text="getErrorObj['email'].join(' ')"
        :maxWidth="700"/>
    <label class="label-field">
      <span class="label-field-title">
        <b>Your message</b>
        <p>{{message.length}}/1000</p>
      </span>
      <textarea
          :class="{error:getErrorObj['message']}"
          v-model="message"
          name="support-comment"
          id="support-comment"
          maxlength="1000"
          cols="30"
          rows="10"
          required />
    </label>
    <InfoMessage
        v-if="getErrorObj['message']"
        message-type="danger"
        :message-text="getErrorObj['message'].join(' ')"
        :maxWidth="700"/>
    <div id="recaptcha" v-if="isEnabledRecaptcha">
      <vue-recaptcha
          ref="recaptcha"
          :sitekey="siteKey"
          @verify="verify"
          @expired="onCaptchaReset"
          :loadRecaptchaScript="true">
      </vue-recaptcha>
    </div>
    <div class="button-box">
      <button @click="submitFeedback"
              type="button"
              class="green-btn flexible"
              :id="create_ticket_id"
              :disabled="isDisabledBtn">
        <span>Send message for feedback</span>
        <span v-if="isDisabledBtn" class="img-loader">
          <img src="../../../public/img/loader.gif">
        </span>
      </button>
    </div>
  </form>
</template>
<script>
  import Vue from "vue";
  import CustomInput from "@/components/CustomInput/CustomInput.vue";
  import InfoMessage from "@/components/AlertMessage/InfoMessage.vue";
  import VueRecaptcha from "vue-recaptcha";
  import {mapGetters} from "vuex";

  export default Vue.extend({
    data() {
      return {
        message: '',
        name: '',
        email: '',
        create_ticket_id: 'create_ticket',
        isDisabledBtn: false,
        isEnabledRecaptcha: eval(process.env.VUE_APP_RECAPTCHA_ENABLED),
        siteKey: process.env.VUE_APP_RECAPTCHA_TOKEN,
        gRecaptcha: '',
      }
    },
    components: {
      CustomInput,
      InfoMessage,
      VueRecaptcha
    },
    computed: {
      ...mapGetters(['getError', 'getErrorObj']),
    },
    watch: {
      message(newMessage, oldMessage) {
        if (!oldMessage && newMessage) this.$store.dispatch('resetOneOfErrors', 'message')
      }
    },
    methods: {
      disabledSendForm() {
        document.getElementById('create_feedback').click();
        return false;
      },
      inputContactMail(data) {
        if (this.getErrorObj['email']) {
          this.$store.dispatch('resetOneOfErrors', 'email')
        }
        this.email = data.inp
      },
      inputContactName(data) {
        if (this.getErrorObj['name'] && data.inp.trim().length > 0) {
          this.$store.dispatch('resetOneOfErrors', 'name')
        }
        this.name = data.inp
      },
      verify(recaptchaToken) {
        this.gRecaptcha = recaptchaToken;
      },
      onCaptchaReset() {
        if (this.isEnabledRecaptcha) {
          this.$refs.recaptcha.reset()
          this.resetCaptchaToken()
        }
      },
      resetCaptchaToken() {
        localStorage.removeItem('_grecaptcha')
        this.gRecaptcha = '';
      },
      submitFeedback() {
        this.isDisabledBtn = true;
        this.$store.dispatch('resetError').then(() => {
          const dataFeedback = {
            opinion: 1,
            category_id: 2,
            category_name: "general",
            name:this.name,
            message: this.message,
            email: this.email,
            grecaptcha: this.gRecaptcha,
          }

          this.$store.dispatch('create_feedback', dataFeedback)
              .then(_ => {
                this.isDisabledBtn = false;
                this.resetCaptchaToken()
                this.$emit('success')
              })
              .catch(error => {

                if (error.response.status === 404) {
                  this.onCaptchaReset()
                }
                this.isDisabledBtn = false;
              })
        })
      },
    }
  })
</script>
<style scoped lang="scss">;
textarea.error {
  border: 1px solid #ea7052!important;
}
</style>